// import { useDispatch } from "react-redux";
// import useFetch from "./hooks/useFetch";
import CreateRoutes from "./routes";
// import { getSiteSettingList } from "./services/siteSettingService";
// import { getSettings } from "./redux/slice/settingsSlice";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import "react-datepicker/dist/react-datepicker.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CreateRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
